module.exports = __webpack_public_path__ + "media/images/lane/dashboard-d81e4ed5154fbb74cf992843ed33396b.png";